<template>
	<div class="vue-wrapper">
	<lane-closure-request-quick-nav v-if="!$store.state.isMobile" v-model="laneClosureRequest" selected="activity"></lane-closure-request-quick-nav>
	<lane-closure-request-quick-nav-mobile v-if="$store.state.isMobile" v-model="laneClosureRequest" selected="activity"></lane-closure-request-quick-nav-mobile>
	<b-container class="laneclosure-activity-container" v-if="loaded">
		<b-form>
			<b-row v-if="$store.state.isMobile">
				<b-col class="pt-0 lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" xl="9">
					<div class="d-flex lcr-page-title">
						<div>
							<h1>Audit Log</h1>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row :class="$store.state.isMobile ? 'lcr-detail-mobile-wrapper' : ''">
				<b-col v-if="!$store.state.isMobile" class="lcr-quick-nav-summary" sm="12" lg="9">
					<b-row>
						<b-col class="pt-0">
							<h1>Audit Log</h1>
						</b-col>
					</b-row>
					<b-row v-if="laneClosureRequest.requesterProjectName">
						<b-col class="pt-1">
							<h2>Project: {{laneClosureRequest.requesterProjectName}}</h2>
						</b-col>
					</b-row>
					<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
				<!-- <div class="d-flex lcr-main-summary">

					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Info</div>
						<div class="lcr-summary__value" v-show="laneClosureRequest.trafficManagementRef.value">TM: {{laneClosureRequest.trafficManagementRef.value}}</div>
						<div class="lcr-summary__value">LCR: {{laneClosureRequest.id}}</div>
					</div>
					<div class="lcr-main-summary__info flex-grow-1">
						<div class="lcr-summary__label">Affected Streets</div>
						<div class="lcr-summary__value">{{directionOfTravel}}</div>
						<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
						<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
					</div>
					<div class="lcr-main-summary__info pt-4">
						<div class="show-on-map-wrapper">
							<a class="show-on-map text-left" @click="showOnMap">
								<span v-if="hideMap" class="on-container">
									<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
									<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
								</span>
								<span v-else class="on-container">
									<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
									<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
								</span>
							</a>
						</div>
					</div>
					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Primary Reason for Closure</div>
						<div class="lcr-summary__value">{{natureOfWork}}</div>
					</div>
					<div class="lcr-main-summary__info ">
						<div class="lcr-summary__label">Date(s)</div>
						<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'MM/DD/YYYY')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'MM/DD/YYYY')}}</div>
						<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'H:mm')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'H:mm')}}</div>
					</div>
					<div class="lcr-main-summary__info" v-if="laneClosureRequest.completeTypeId.value != null">
						<div class="lcr-summary__label">Complete Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.completeTypeId.value)}}</div>
					</div>
					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Approval Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.approvalStatusId.value)}}</div>
						<div class="lcr-summary__label">Record Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.recordStatusId.value)}}</div>
					</div>

				</div> -->

				</b-col>
				<b-col v-if="$store.state.isMobile" class="lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" lg="9">
					<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
				</b-col>
			</b-row>

			<b-row align-h="center">
				<template v-if="auditLoaded">
					<b-col class="mt-3" lg="6">
					<audit-log-listing v-for="(log, z) in auditBatches"
					:batchDetail="{user: log.userName, notes: log.batchNotes, time: Format.toLocalDateTime(log.batchDate, 'MM/DD/YYYY HH:mm:ss'), auditTypeId: log.auditTypeId,
					organizationName: log.organizationName, organizationType: log.organizationType, id:log.id}"
					:logs="log.auditLog" :lcr="laneClosureRequest" 
 					v-bind:key="'auditBatches-'+z+'-'+Math.random()"
					/>
					</b-col>
				</template>
				<template v-else>
					<Spinner />
				</template>
			</b-row>

		</b-form>

</b-container>
<Spinner v-else />
</div>
</template>


<script>
import LaneClosureRequestQuickNav from '../../components/LaneClosureRequestQuickNav.vue';
import LaneClosureViewInfo from '../../components/LaneClosureViewInfo.vue';
import LaneClosureRequestQuickNavMobile from '../../components/LaneClosureRequestQuickNavMobile.vue';
import Vue from 'vue'
import ErrorHandler from '../../utility/ErrorHandler';
import LaneClosureRequest from '../../models/LaneClosureRequest';
import Attachment from '../../models/Attachment';
import KMLHelper from '../../utility/KMLHelper';
import Format from '../../utility/Format';
import LaneClosureRequestBlock from '../../models/LaneClosureRequestBlock';
import AuditLogListing from '../../components/AuditLogListing.vue';
import Spinner from "./../../components/Spinner.vue"

import store from "../../store";


export default {
	name: 'LaneClosureRequestActivity',
	docTitle() {
		return `Request ${this.id} Audit Log - Lane Closures`;
	},

	components: {
		LaneClosureRequestQuickNav,
		LaneClosureViewInfo,
		LaneClosureRequestQuickNavMobile,
		AuditLogListing,
		Spinner,
	},
	props: ['id'],
	data() {
		return {
			Format,
		laneClosureRequest: null,
		auditBatches: null,
		LaneClosureRequest,
		loaded:false,
		auditLoaded: false,
		hideMap: false,
	}
},
mounted() {
		this.auditLoaded = false;
		this.LoadLaneClosureRequest();
		this.$nextTick(() => {
		});
		Vue.prototype.$http({
			method: 'get',
			url: `${this.$store.state.apiUrl}/audit-log/view/${this.id}/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
		}).then(res => {
			this.auditBatches = res.data;
			this.auditLoaded = true;
		})

		this.hideMap = Vue.prototype.$mapShown;
		this.$bus.$off('map:shown', this.changeToHideMap);
		this.$bus.$off('map:hidden', this.changeToShowMap);
		this.$bus.$on('map:shown', this.changeToHideMap);
		this.$bus.$on('map:hidden', this.changeToShowMap);
	},
	computed: {
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				return Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},
		getPeakIdText() {
			if (this.laneClosureRequest.peakId.value) {
				return Format.searchById(this.laneClosureRequest.peakId.value, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},

		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		},
	},

	watch: {
		'$route.params': function() {
		},
	},

	methods: {

		showOnMap() {
			Vue.prototype.$bus.$emit("map:toggle", null, this.hideMap ? 0 : 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
				this.setAllPolylineColours();
			});
		},

		setAllPolylineColours() {
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
					}
				}
			}
		},
		SaveAttachmentComment(obj) {
			if (obj.comments != null && obj.comments != "" && obj.attachmentId != null) {
				let postData = {
					comments:obj.comments
				}
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/comment?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: postData
					}).then(resp => {

				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},



		handleFilePondAddFile(e, file, m) {
		},
		handleFilePondInit: function() {
				this.$refs.pond._pond.setOptions({
					server: {
						header: {
							Authorization: "Bearer "+ this.$store.state.token
						},
						process: {
							method: 'POST',
							url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
							withCredentials: true
						},

						//  url: this.$store.state.apiUrl},
						// timeout: 7000,
						//  process: {
						//      method: 'POST',
						//      url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						//      withCredentials: true,
						//      headers: this.$axios.defaults.headers.common
						//  },
						//  revert: (uniqueFileId, load, error) => {
						//      // remove from toUpload
						//      var index = this.userFiles.toUpload.indexOf(uniqueFileId);
						//      if (index > -1) {
						//          this.userFiles.toUpload.splice(index, 1);
						//      }
						//      // Should remove the earlier created temp file here
						//      this.$axios.post(`${this.$store.state.apiUrl}/attachment/revert?r=${Math.round(Math.random() * Math.pow(10, 6))}`, {
						//          _method: 'DELETE',
						//          uniqueID: uniqueFileId,
						//          resource: this.options.resource
						//      });

						//      // error();
						//      load();
						//  },
						//  load: {
						//      method: 'GET',
						//      url: '/img/'
						//  }
					}
				});
				this.$refs.pond._pond.setOptions({
					fileMetadataObject: {
						comments: null,
						sourceTable: "lcr_attachment",
						sourceId: this.laneClosureRequest.id
					},
					allowImagePreview: false,
					allowRevert: false,
					allowReorder: false,
					allowReplace:false,
					server: {
						url:`${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						headers: {
							Authorization: "Bearer "+ this.$store.state.token
						}
					}
				});
		},

		handleFilePondProcessFileStart(e,p) {
			this.isButtonDisabled = true;
		},
		handleFilePondProcessAllFiles(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessError(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessAbort(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessFile(e, p) {
			if (p.error) {
				// there was a problem!
			} else {
				let attachmentData = JSON.parse(p.serverId);
				this.laneClosureRequest.attachment.unshift(new Attachment(attachmentData.attachment));
			}

		},
		LoadLaneClosureRequest(id = this.id) {
				this.loaded = false;
					// Remove any messages being displayed.
					this.submissionStatus = null;

					if (id && Format.TryParseInt(id) > 0) {
						this.GetLaneClosureRequest(id);
					}
					else {
						if (this.data) {
							this.laneClosureRequest = new LaneClosureRequest(this.data);
							this.laneClosureRequest.saveChanges();
						} else {
							this.laneClosureRequest = new LaneClosureRequest();
							// {useTestData:true}
						}
						this.loaded = true;
					}


				},
				// Loads lane closure request into the component based on provided id.
				GetLaneClosureRequest(id) {
					if (Format.TryParseInt(id)) {
						this.loaded = false;
						Vue.prototype.$http({
							method: 'get',
							url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/view?r=${Math.round(Math.random() * Math.pow(10, 6))}`
						}).then(response => {
							this.laneClosureRequest = new LaneClosureRequest(response.data.request);
							this.loaded = true;
							if (this.laneClosureRequest.block) {
								let x = 0;
								for (x = 0; x < this.laneClosureRequest.block.length; x++) {
									this.setBlockPolyline(this.laneClosureRequest.block[x]);
								}
								this.zoomAllBlocks();
							}
							if (this.$store.getters.userHasRole('internal_admin_requests')) {
								if (this.laneClosureRequest.recordStatusId.value == 2) {	// New, automatically set it to Under Review
									this.laneClosureRequest.recordStatusId.value = 3;
									this.postSetStatus(false);
								}
							}



						}).catch(error => {
							if (!ErrorHandler.HasLoginErrorCode(error)) {
								if (error.response && error.response.data) {
									this.loaded = false;
									this.transactionStatus = 'load-error';
									this.errorDetails = error.response.data;
								}
								else {
									console.error(error);
								}
							} else {
								// ErrorHandler.RedirectToLogin();
							}
						});
					}

				},
				zoomAllBlocks() {
					this.$store.dispatch("map/zoomAllBlocks", null);
				},
				zoomToBlockId(id) {
					var bounds = new google.maps.LatLngBounds();
					let setBounds = false;
					if (this.laneClosureRequest.block) {
						let x = 0;
						let z = 0;
						for (x =0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].mapPolyline && this.laneClosureRequest.block[x].blockId == id ) {
								let polyBounds = this.laneClosureRequest.block[x].mapPolyline.getPath();
								for (z = 0; z < polyBounds.length; z++) {
									bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
								}
								setBounds = true;
							}
						}
					}
					if (setBounds) {
						this.$store.state.map.map.fitBounds(bounds);
					}
				},

				setBlockPolyline(block) {
					let that = this;
					let foundIndex = null;
					let blockPolyline = null;
					if (block) {
						// find the existing marker/placemark.
						if (this.laneClosureRequest.block) {
							for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
								if (this.laneClosureRequest.block[x].blockId == block.blockId) {
									foundIndex = x;
									if (that.$store.getters["map/polylines"]) {
										for (x =0; x < that.$store.getters["map/polylines"].length; x++) {
											if (that.$store.getters["map/polylines"][x]) {
											if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
												blockPolyline = that.$store.getters["map/polylines"][x];
											}
										}
										}
									}
								}
							}
						}
						if (foundIndex == null || blockPolyline == null) {
							// add the block to the map.
							// look for existing block in lane closure request, and select it.
							var myParser = new Vue.prototype.$geoXML3.parser({map:null, afterParse: function(doc) {
								let xx = 0;
								var coords = [];
								let zz = 0;
								for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
									for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
										coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
									}
								}

							let mapPolyline = new google.maps.Polyline({
									map: that.$store.state.map.map,
									path: coords,
									strokeColor: '#666666',
									strokeOpacity: 1.0,
									strokeWeight: 8
									});
							mapPolyline.blockData = block;
							let mapIndex = -1;
							if (foundIndex == null) {
								let newBlock = new LaneClosureRequestBlock(block);
									that.laneClosureRequest.block.push(newBlock);
									foundIndex = that.laneClosureRequest.block.length - 1;
									}
									if (that.$store.getters["map/polylines"]) {
										for (x =0; x < that.$store.getters["map/polylines"].length; x++) {
											if (that.$store.getters["map/polylines"][x]) {
											if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
												that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
												mapIndex = x;
											}
											}
										}
									}
							if (mapIndex == -1) {
								// not found, so add the polyline.
								that.$store.commit("map/addPolyline", mapPolyline);
							}
							google.maps.event.addListener(mapPolyline, 'click', function() {
								that.$bus.$emit('view-lcr:map:block-edit', this.blockData.blockId);
								});
								return;
							}
							});
							let kmlString = "";
							if (block.kml != "") {
								let color = "7fff0000";
								if (block.streetName != that.laneClosureRequest.affectedStreet.value) {
									// turning restriction
									color = "7f000000"
								}
								kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
								kmlString = KMLHelper.finalizeKml(kmlString);
								myParser.parseKmlString(kmlString);
							}
						}
					}
				},

				changeToHideMap(x) {
					this.hideMap = true;
				},
				changeToShowMap(x) {
					this.hideMap = false;
				},
	},
	beforeRouteEnter(to, from, next) {
		if (store.getters.userHasRole('internal_admin_requests') || store.getters.userHasRole('system_admin') || store.getters.userHasRole('internal_admin_reports') || store.getters.userHasRole('manager_requests')) {
			next(true);
		} else {
			next(`/lane-closure-request/${to.params.id}/view`);
		}
	},
	created() {
	},
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>